export default class Tabs {
  constructor() {
    this.$comments = $('.tab-comments');
  }

  tab() {

    $('.tab-nav').children().on('click', (e) => {
      e.preventDefault();
      const el = $(e.currentTarget);
      const index = el.index();
      el.addClass('active').siblings().removeClass('active');

      $('.tab-content').children().eq(index).addClass('active').siblings().removeClass('active')
    });

    $('.tab-nav').children().first().click()
  }

  init() {
    this.tab();
  }
}
